app.controller("StIndexController", ["$scope", "Students", "$uibModal", "$state", "$stateParams", "AuthService", "ProgramService", "StaticData", "UserConfigService",
    function ($scope, Students, $uibModal, $state, $stateParams, AuthService, ProgramService, StaticData, UserConfigService) {
        $scope.format = "dd/MM/yyyy";

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = faculties;
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        StaticData.getItemsByKey("gender").then(function (gender) {
            $scope.gender = gender;
            $scope.genderMap = _.keyBy($scope.gender, '_id');
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.states = states;
            $scope.statesMap = _.keyBy($scope.states, '_id');
        });

        AuthService.getUserData().then(function (user) {
            $scope.profile = user.profiles.filter(function (p) {
                return p.type === 'student' && p.state === 'active'
            })[0];

            ProgramService.fetchOne($scope.profile.program).then(function (program) {
                $scope.program = program;
            });

            if(!user.photo && user.gender == 'male') user.defaultPhoto = "img/male.jpg";
            if(!user.photo && user.gender == 'female') user.defaultPhoto = "img/female.jpg";
            else if(!user.photo && !user.gender) user.defaultPhoto = "img/no_image.jpg";

            $scope.user = user;
        });

        $scope.newDesign = function () {
            UserConfigService.set({key: 'newDesign', value: true});
            $state.go('student-new.index')
        }
    }
]);